import logo from "../images/Mobile2Logo.svg"
import { useState, useEffect, useRef } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { MemberProfileSmall, ProfileSmall } from "./ProfileComponents";
import { GlobalNotificationComponent } from "./NotificationComponents";
import { LanguageDropdown } from "./LanguageComponents";
import { useTranslation } from "react-i18next";
import { IoMenuOutline } from "react-icons/io5";
import DarkModeToggle, { darkAndLightThemeDefault } from "./ThemeComponents";


function NavBar() {
    const { t } = useTranslation('common')
    const navigator = useNavigate();

    const menuRef = useRef(null)
    const buttonRef = useRef(null)
    const [menuOpen, setMenuOpen] = useState(false)


    const toggleMenu = () => setMenuOpen(!menuOpen)

    const handleTouchOutside = (event) => {
        const menuContainer = menuRef.current
        const buttonContainer = buttonRef.current
        if (menuContainer && !menuContainer.contains(event.target) && !buttonContainer.contains(event.target) && menuOpen) {
            setMenuOpen(false)
        }

    }

    useEffect(() => {

        document.addEventListener('touchend', handleTouchOutside)

        return () => {
            document.removeEventListener('touchend', handleTouchOutside)
        }

    }, [menuOpen])

    const handleNavigateFAQ = () => {
        navigator("/faq")
    }

    const handleNavigateHome = () => {
        navigator("/home")
    }

    const handleCreateTicket = () => {
        navigator("/create-ticket")
    }

    return (
        <nav className="navbar bg-white dark:bg-gray-700  rounded-xl mx-auto max-w-[1300px] shadow-sm sm:px-10 mt-5 z-10">
            <div className="">

                <a className="block cursor-pointer" href="https://mobile2.global">
                    <img
                        src={logo}
                        alt="Home"
                        className=""
                        width="180"
                    />
                </a>
            </div>
            <div className="hidden sm:flex ltr:ml-auto rtl:mr-auto">
                <ul className="hiddenmenu menu-horizontal items-center px-1 gap-1">
                    <li>
                        <a className={`btn btn-sm ${darkAndLightThemeDefault}`} onClick={handleNavigateHome}>{t("Home")}</a>
                    </li>
                    {/* <li>
                        <a className={`btn btn-sm ${darkAndLightThemeDefault}`} onClick={handleCreateTicket}>{t("Create Ticket")}</a>
                    </li> */}
                    <li>
                        <a className={`btn btn-sm ${darkAndLightThemeDefault}`} onClick={handleNavigateFAQ}>{t("FAQ")}</a>
                    </li>
                    <LanguageDropdown />
                    <DarkModeToggle small={true} />
                </ul>
            </div>
            <div className="sm:hidden flex-none relative gap-1 ltr:ml-auto rtl:mr-auto">
                <button className={`btn btn-sm w-10 h-10 btn-circle ${darkAndLightThemeDefault}`} onClick={toggleMenu} ref={buttonRef}><IoMenuOutline size={20} /></button>
                {
                    menuOpen &&
                    <ul className="absolute top-full ltr:right-0 rtl:left-0 menu flex-col bg-gray-100 dark:bg-gray-800 rounded-lg shadow-xl border border-gray-200 dark:border-gray-600 mt-2 p-2 w-48 gap-1 z-[100]" ref={menuRef}>
                        <li>
                            <a className={`btn btn-sm justify-start w-full ${darkAndLightThemeDefault}`} onClick={handleNavigateHome}>{t("Home")}</a>
                        </li>
                        <li>
                            <a className={`btn btn-sm justify-start w-full ${darkAndLightThemeDefault}`} onClick={handleNavigateFAQ}>{t("FAQ")}</a>
                        </li>
                    </ul>
                }

                <LanguageDropdown />
                <DarkModeToggle small={true} />

            </div>
        </nav>
    )
}


export function Header() {

    return (
        <div className="flex w-full justify-between pt-2 pb-5 ltr:pl-2 rtl:pr-2 px-2">
            <div className="flex gap-2 items-center">
                <label htmlFor="my-drawer-2" className="btn btn-sm btn-circle bg-transparent border-none shadow-none lg:hidden text-gray-800 dark:text-gray-300">
                    <IoMenuOutline size={24} />
                </label>
                <ProfileSmall />
                <DarkModeToggle />
            </div>
            {/* <LanguageDropdown /> */}
            <GlobalNotificationComponent />
        </div>
    )
}


export const MemberNavbar = () => {
    const { t } = useTranslation('common')
    const navigator = useNavigate()


    const menuRef = useRef(null)
    const buttonRef = useRef(null)
    const [menuOpen, setMenuOpen] = useState(false)


    const toggleMenu = () => setMenuOpen(!menuOpen)

    const handleTouchOutside = (event) => {
        const menuContainer = menuRef.current
        const buttonContainer = buttonRef.current
        if (menuContainer && !menuContainer.contains(event.target) && !buttonContainer.contains(event.target) && menuOpen) {
            setMenuOpen(false)
        }

    }

    useEffect(() => {

        document.addEventListener('touchend', handleTouchOutside)

        return () => {
            document.removeEventListener('touchend', handleTouchOutside)
        }

    }, [menuOpen])


    const handleNavigateHome = () => {
        navigator("/member/home")
    }


    const handleNavigateCreteTicket = () => {
        navigator("/member/create-ticket")
    }

    const handleNavigateTicketHistory = () => {
        navigator("/member/ticket-history")
    }

    const handleNavigateFAQ = () => {
        navigator("/member/faq")
    }

    return (
        <div className="self-center flex w-full items-center justify-between gap-1 pb-1 pt-2 max-w-[1200px]">
            <div className="">
                <MemberProfileSmall />
            </div>
            <div className="hidden sm:flex ltr:ml-auto rtl:mr-auto">
                <ul className="menu menu-horizontal items-center px-1 gap-1">
                    <li>
                        <a className={`btn btn-sm ${darkAndLightThemeDefault}`} onClick={handleNavigateHome}>{t("Home")}</a>
                    </li>
                    <li>
                        <a className={`btn btn-sm ${darkAndLightThemeDefault}`} onClick={handleNavigateCreteTicket}>{t("Create Ticket")}</a>
                    </li>
                    <li>
                        <a className={`btn btn-sm ${darkAndLightThemeDefault}`} onClick={handleNavigateTicketHistory}>{t("Ticket History")}</a>
                    </li>
                    <li>
                        <a className={`btn btn-sm ${darkAndLightThemeDefault}`} onClick={handleNavigateFAQ}>{t("FAQ")}</a>
                    </li>
                    <LanguageDropdown />
                    <DarkModeToggle small={true} />
                </ul>
            </div>
            <div className="sm:hidden flex relative gap-1 ltr:ml-auto rtl:mr-auto px-1">
                <button className={`btn btn-sm w-10 h-10 btn-circle ${darkAndLightThemeDefault}`} onClick={toggleMenu} ref={buttonRef}><IoMenuOutline size={20} /></button>
                {
                    menuOpen &&
                    <ul className="absolute top-full ltr:right-0 rtl:left-0 menu flex-col bg-gray-100 dark:bg-gray-800 rounded-lg shadow-xl border border-gray-200 dark:border-gray-600 mt-2 p-2 w-56 gap-1 z-[100]" ref={menuRef}>
                        <li>
                            <a className={`btn btn-sm justify-start w-full ${darkAndLightThemeDefault}`} onClick={handleNavigateHome}>{t("Home")}</a>
                        </li>
                        <li>
                            <a className={`btn btn-sm justify-start w-full ${darkAndLightThemeDefault}`} onClick={handleNavigateCreteTicket}>{t("Create Ticket")}</a>
                        </li>
                        <li>
                            <a className={`btn btn-sm justify-start w-full ${darkAndLightThemeDefault}`} onClick={handleNavigateTicketHistory}>{t("Ticket History")}</a>
                        </li>
                        <li>
                            <a className={`btn btn-sm justify-start w-full ${darkAndLightThemeDefault}`} onClick={handleNavigateFAQ}>{t("FAQ")}</a>
                        </li>
                    </ul>

                }
                <LanguageDropdown />
                <DarkModeToggle small={true} />
            </div>
        </div>
    )
}


export default NavBar;